const FancyArrowUp = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.502 17.7419C12.8427 17.1131 13.2273 16.5787 13.6859 16.1198C14.6362 15.1686 15.8572 14.5881 17.5214 14.1114C17.7868 14.0353 18.0637 14.1889 18.1397 14.4543C18.2158 14.7198 18.0622 14.9966 17.7968 15.0727C16.2086 15.5277 15.1726 16.0467 14.3933 16.8266C13.61 17.6105 13.0392 18.7045 12.4769 20.4058C12.4073 20.6165 12.211 20.7498 12.0005 20.749C11.79 20.7498 11.5937 20.6165 11.524 20.4058C10.9617 18.7045 10.391 17.6105 9.60769 16.8266C8.82842 16.0467 7.79242 15.5277 6.20422 15.0727C5.93876 14.9966 5.78521 14.7198 5.86126 14.4543C5.93731 14.1889 6.21416 14.0353 6.47963 14.1114C8.14377 14.5881 9.36475 15.1686 10.3151 16.1198C10.775 16.58 11.1605 17.1162 11.502 17.7473L11.502 3.74902C11.502 3.47288 11.7258 3.24902 12.002 3.24902C12.2781 3.24902 12.502 3.47288 12.502 3.74902L12.502 17.7419Z"
        fill="#646464"
      />
    </svg>
  )
}

export default FancyArrowUp
